import { getDevice, getDeviceDetail, getGraphic } from "@/api/device";
import {changeCbid} from "@/api/device";

const state = {
  deviceVersion: '',   // 设备历史数据
  onlineStat: false,
  excelName: '',
};

const getters = {
  deviceVersion: state => state.deviceVersion,
  onlineStat: state => state.onlineStat,
  excelName: state => state.excelName,
};

const mutations = {
  DEVICE_VERSION(state, value) {
    state.deviceVersion = value;
  },
  ONLINE_STAT(state, value) {
    state.onlineStat = value;
  },
  EXCEL_NAME(state, value) {
    state.excelName = value;
  },

};

const actions = {
  getDevice({commit}, param) {
    return new Promise((resolve, reject) => {
      getDevice(param).then(res => {
        commit("DEVICE_VERSION", res.version)
        commit("ONLINE_STAT", res.onlineStat)
        commit("EXCEL_NAME", res.name)
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  getDeviceDetail({commit}, param) {
    return new Promise((resolve, reject) => {
      getDeviceDetail(param).then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  getGraphic({commit}, param) {
    return new Promise((resolve, reject) => {
      getGraphic(param).then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  changeCbid({commit}, param) {
    return new Promise((resolve, reject) => {
      changeCbid(param).then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  controlCbid({commit}, param) {
    return new Promise((resolve, reject) => {
      controlCbid(param).then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  },

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/device.js